var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "privacy-policy simple-text" }, [
      _c("p", [
        _vm._v(
          "This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [
        _vm._v(
          "What personal information do we collect from the people that visit our blog, website or app?"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address, mailing address, phone number or other details to help you with your experience."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("When do we collect information?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We collect information from you when you register on our site, fill out a form or enter information on our site."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("How do we use your information?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:"
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "To allow us to better service you in responding to your customer service requests."
          ),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("To quickly process your transactions.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("To ask for ratings and reviews of services or products"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "To follow up with them after correspondence (live chat, email or phone inquiries)"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("How do we protect your information?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible."
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("We use regular Malware Scanning.")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We implement a variety of security measures when a user places an order enters, submits, or accesses their information to maintain the safety of your personal information."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "All transactions are processed through a gateway provider and are not stored or processed on our servers."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Do we use 'cookies'?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future."
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("We use cookies to:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("Understand and save user's preferences for future visits."),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies."
        ),
      ]),
      _c("p", [
        _vm._v(
          "If you turn cookies off, Some of the features that make your site experience more efficient may not function properly.It won't affect the user's experience that make your site experience more efficient and may not function properly."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Third-party disclosure ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Third-party links")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Google")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://support.google.com/adwordspolicy/answer/1316548?hl=en",
              target: "_blank",
            },
          },
          [
            _vm._v(
              "https://support.google.com/adwordspolicy/answer/1316548?hl=en"
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We have not enabled Google AdSense on our site but we may do so in the future."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("California Online Privacy Protection Act")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. The law's reach stretches well beyond California to require any person or company in the United States (and conceivably the world) that operates websites collecting Personally Identifiable Information from California consumers to post a conspicuous privacy policy on its website stating exactly the information being collected and those individuals or companies with whom it is being shared. - See more at: "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf",
              target: "_blank",
            },
          },
          [
            _vm._v(
              " http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf"
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("According to CalOPPA, we agree to the following:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("Users can visit our site anonymously.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified above."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("You will be notified of any Privacy Policy changes:")]),
      _vm._v(" "),
      _c("ul", [_c("li", [_vm._v("On our Privacy Policy Page")])]),
      _vm._v(" "),
      _c("p", [_vm._v("Can change your personal information:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("By emailing us")]),
        _vm._v(" "),
        _c("li", [_vm._v("By logging in to your account")]),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("How does our site handle Do Not Track signals?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [
        _vm._v("Does our site allow third-party behavioral tracking?"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "WIt's also important to note that we do not allow third-party behavioral tracking"
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("COPPA (Children Online Privacy Protection Act)")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?"
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Fair Information Practices")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical to comply with the various privacy laws that protect personal information."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:"
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("We will notify you via email")]),
        _vm._v(" "),
        _c("li", [_vm._v("Within 7 business days")]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors."
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("CAN SPAM Act")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations."
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("We collect your email address in order to:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Send information, respond to inquiries, and/or other requests or questions"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Process orders and to send information and updates pertaining to orders."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Send you additional information related to your product and/or service"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Market to our mailing list or continue to send emails to our clients after the original transaction has occurred."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("To be in accordance with CANSPAM, we agree to the following:"),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("Not use false or misleading subjects or email addresses."),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Identify the message as an advertisement in some reasonable way."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Include the physical address of our business or site headquarters."
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Monitor third-party email marketing services for compliance, if one is used."
          ),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Honor opt-out/unsubscribe requests quickly.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Allow users to unsubscribe by using the link at the bottom of each email."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "If at any time you would like to unsubscribe from receiving future emails, you can email us at"
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("Follow the instructions at the bottom of each email. "),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("and we will promptly remove you from ALL correspondence."),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "h4-title popup__text-title" }, [
        _vm._v("Contacting Us"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "If there are any questions regarding this privacy policy, you may contact us using the information below."
        ),
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "https://goplanr.com", target: "_blank" } }, [
        _vm._v("www.goplanr.com"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(" 10 Storey's Gate"),
        _c("br"),
        _vm._v("London, London SW1P 3AY"),
        _c("br"),
        _vm._v("UK"),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "mailto:info@goplanr.com" } }, [
          _vm._v("info@goplanr.com"),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Last Edited on 2018-02-28")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }